import React, {useContext, useEffect, useState} from "react";
import PropTypes from 'prop-types';
import {IconButton, Tooltip, TextField, makeStyles} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import ClearSharpIcon from '@material-ui/icons/ClearSharp';
import _ from 'lodash';
import listRequestWrapper from "../../../../../../../../../Services/API/listRequestWrapper";
import ValueInput from "./ValueInput";
import {ScreenDesignerContextNew} from "../../../../../../../../../ContextComponents/ScreenDesignerContextNew";
import findByString from "../../../../../../../../../Utils/Form/FormDynamic/Utils/getValueByString";
import {useSelector} from "react-redux";
import {multiLanguageValue} from "../../../../../../../../JsonScreen/Utils/lib";

const grayBorder = '1px solid rgba(0, 0, 0, 0.12)';
const useStyles = makeStyles(() => ({
    tagValueWrapperHeader: {
        display: 'flex',
        width: '100%',
        height: 27
    },
    tagValueWrapper: {
        display: 'flex',
        width: '100%',
        '& $option': {
            visibility: 'hidden'
        },
        '&:hover': {
            '& $option': {
                visibility: 'visible'
            },
        }
    },
    column: {
        width: '25%',
        borderLeft: grayBorder,
        // borderBottom: grayBorder,
    },
    operand: {
        width: '25%',
        borderLeft: grayBorder,
        //  borderBottom: grayBorder,
    },
    value: {
        width: '50%',
        borderLeft: grayBorder,
        //   borderBottom: grayBorder,
        borderRight: grayBorder,
        maxWidth: 355
    },
    valueHalf: {
        width: '25%',
        borderLeft: grayBorder,
        maxWidth: 177.5
    },
    valueHalfRange: {
        width: '25%',
        borderLeft: grayBorder,
        borderRight: grayBorder,
        maxWidth: 177.5
    },
    option: {
        display: 'flex',
        alignItems: 'center',
        width: 0
    },
    optionHeader: {
        width: 0,
    },
    columnHeader: {
        background: '#fafafa',
        width: '25%',
        borderTop: grayBorder,
        borderLeft: grayBorder,
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    operandHeader: {
        background: '#fafafa',
        width: '25%',
        borderTop: grayBorder,
        borderLeft: grayBorder,
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    valueHeader: {
        background: '#fafafa',
        width: '50%',
        borderTop: grayBorder,
        borderLeft: grayBorder,
        borderRight: grayBorder,
        textAlign: 'center',
        maxWidth: 355,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    optionBtn: {
        padding: 0,
        left: -25
    },
    valueInputRoot: {
        paddingRight: 0
    },
    optionAutoComplete: {
        minHeight: 2,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        cursor: 'pointer',
        paddingTop: 1,
        boxSizing: 'border-box',
        outline: '0',
        WebkitTapHighlightColor: 'transparent',
        paddingBottom: 2,
        paddingLeft: 16,
        paddingRight: 16,
    },
    paramActionWrapper: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end'
    },
    paramActionLine: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 2,
        cursor: 'pointer',
        borderLeft: grayBorder,
        borderRight: grayBorder,
        borderBottom: grayBorder,
        transition: 'all 0.2s ease',
        '& span': {
            display: 'none'
        },
        '&:hover': {
            height: 9,
            background: 'transparent',
            borderTop: grayBorder,
            borderLeft: 'none',
            borderRight: 'none',
            borderBottom: grayBorder,
            transition: 'all 0.2s ease',
            '& span': {
                display: 'block',
                color: 'rgba(0, 0, 0, 0.42)'
            }
        }
    }
}));

const SetFilterParams = ({param, setValue, path, createParam, removeParam, actionIndex, onKeyDown, action}) => {
    const {lists} = useContext(ScreenDesignerContextNew);
    const [columns, setColumns] = useState([]);
    const [operands, setOperands] = useState([]);
    const listName = findByString(action, 'destination');
    const fetchOperands = async () => {
        return await listRequestWrapper('operand');
        /*
        * operand: {id: "contains", name: "Contains", type: ['STRING', 'NUMBER', 'INTEGER' ...]}
        *
        * */

    };
    const onChangeColumn = (column, index) => {
        if (_.isObject(column)) {
            setValue(column.name, `${path}.param.${index}.column`);
        } else {
            setValue(column ? column : "", `${path}.param.${index}.column`);
        }
    };
    const onChangeOperand = (operand, index) => {
        setValue(operand ? operand.id : "", `${path}.param.${index}.operand`);
    };

    const classes = useStyles();
    useEffect(() => {
        async function fetch() {
            const operandsResponse = await fetchOperands();
            let listColumns = [];
            if (lists[listName]) {
                //check for additional defined filterFields,
                //if filterFields defined, it should be instead of columns, and operands should be defined from
                //filterField object
                if (lists[listName].filterFields) {
                    listColumns = lists[listName].filterFields.map(f => {
                        let currentOperands = [];
                        if (f.operands) {
                            currentOperands = f.operands.map(o => {
                                const fullOperand = getOperandByName(o, operandsResponse);
                                return {id: o, name: fullOperand.name}
                            });
                        } else {
                            currentOperands = operandsResponse;
                        }
                        return {name: f.name, type: f.type, label: f.label, operands: currentOperands}
                    })
                } else {
                    listColumns = lists[listName].columns;
                }
            }

            /*
            * column: {name: "listName", label: "labelList", type: "string"}
            *
            * */
            setColumns(listColumns || []);
            setOperands(operandsResponse || []);
        }

        fetch();
    }, [listName]);

    return (
        <>
            <div className={classes.tagValueWrapperHeader}>
                <div className={classes.columnHeader}>Column</div>
                <div className={classes.operandHeader}>Operand</div>
                <div className={classes.valueHeader}>Value</div>
                <div className={classes.optionHeader}></div>
            </div>
            {(param || [{}]).map((par, index) => {
                const isRange = par.operand === 'range' || par.operand === '!range';
                return (
                    <React.Fragment key={index}>
                        {index === 0 && (
                            <div className={classes.paramActionLine}
                                 onClick={() => createParam(actionIndex, index)}>
                                <span>+</span>
                            </div>
                        )}
                        <div className={classes.tagValueWrapper} onKeyDown={(e) => onKeyDown(e, index)}>
                            <div className={classes.column}>
                                <ColumnField
                                    columns={columns}
                                    onChange={onChangeColumn}
                                    index={index}
                                    value={par.column || ""}
                                />
                            </div>
                            <div className={classes.operand}>
                                <OperandField
                                    operands={operands}
                                    columns={columns}
                                    onChange={onChangeOperand}
                                    index={index}
                                    value={par.operand || ""}
                                    param={par}
                                />
                            </div>
                            <div className={isRange ? classes.valueHalf : classes.value}>
                                <div style={{maxWidth: 330}}>
                                    <ValueInput
                                        setValue={setValue}
                                        path={path}
                                        currentParam={par}
                                        paramIndex={index}
                                        actionIndex={actionIndex}
                                        param={param}
                                        createParam={isRange ? () => {
                                        } : createParam}
                                    />
                                </div>
                            </div>
                            {isRange && (
                                <div className={classes.valueHalfRange}>
                                    <div style={{maxWidth: 165}}>
                                        <ValueInput
                                            setValue={setValue}
                                            path={path}
                                            valueName={'value2'}
                                            currentParam={par}
                                            paramIndex={index}
                                            actionIndex={actionIndex}
                                            createParam={createParam}
                                            param={param}
                                        />
                                    </div>
                                </div>
                            )}
                            <div className={classes.option}>
                                <Tooltip title={'Remove Param'}>
                                    <IconButton tabIndex={-1}
                                                onClick={() => removeParam(actionIndex, index)}
                                                className={classes.optionBtn}>
                                        <ClearSharpIcon fontSize={"small"}/>
                                    </IconButton>
                                </Tooltip>
                            </div>
                        </div>
                        <div className={classes.paramActionLine}
                             onClick={() => createParam(actionIndex, index + 1)}>
                            <span>+</span>
                        </div>
                    </React.Fragment>
                )
            })}
        </>
    )
};
export default SetFilterParams

SetFilterParams.propTypes = {
    param: PropTypes.array,
    setValue: PropTypes.func,
    path: PropTypes.string,
    selectedComponent: PropTypes.object,
    lists: PropTypes.object,
    createParam: PropTypes.func,
    removeParam: PropTypes.func,
    actionIndex: PropTypes.number
};


const ColumnField = ({columns, onChange, index, value}) => {
    const classes = useStyles();
    const currentValue = getColumnByName(value, columns);
    const {userLanguage} = useSelector(state => state.app);
    return (
        <Autocomplete
            options={columns}
            freeSolo
            onChange={(e, v) => onChange(v, index)}
            value={currentValue || {label: ""}}
            inputValue={_.isObject(currentValue) ? multiLanguageValue(currentValue.label, userLanguage) : currentValue || ""}
            size={"small"}
            getOptionLabel={(o) => multiLanguageValue(o.label, userLanguage)}
            classes={{inputRoot: classes.valueInputRoot, option: classes.optionAutoComplete}}
            closeIcon={<></>}
            renderInput={(params) => {
                return (
                    <TextField
                        {...params}
                        onChange={(e) => onChange(e.target.value, index)}
                        InputProps={{
                            ...params.InputProps,
                            disableUnderline: true
                        }}
                        fullWidth
                    />
                )
            }}
        />
    )
};
const OperandField = ({operands, onChange, index, value, param, columns}) => {
    const currentColumnType = getColumnType(columns, param.column);
    const operandsOptions = operandsByType(operands, currentColumnType);
    const classes = useStyles();
    return (
        <Autocomplete
            options={operandsOptions}
            onChange={(e, v) => onChange(v, index)}
            value={getOperandByName(value, operands) || {name: ""}}
            size={"small"}
            getOptionLabel={(o) => o.name || ""}
            classes={{inputRoot: classes.valueInputRoot, option: classes.optionAutoComplete}}
            closeIcon={<></>}
            renderInput={(params) => {
                return (
                    <TextField
                        {...params}
                        InputProps={{
                            ...params.InputProps,
                            disableUnderline: true
                        }}
                        fullWidth
                    />
                )
            }}
        />
    )
};

function operandsByType(operands, type) {
    let operandsByType = [];
    if (type) {
        operands.forEach(op => {
            if (!op.type) {
                operandsByType.push(op)
            } else {
                op.type.forEach(t => {
                    if (t === type.toUpperCase()) {
                        operandsByType.push(op)
                    }
                })
            }
        });
        return operandsByType
    } else {
        return operands
    }

}

function getOperandByName(name, operands) {
    let fullOperand = {};
    operands.forEach(o => {
        if (name === o.id) {
            fullOperand = o
        }
    });
    return fullOperand
}

function getColumnByName(name, columns) {
    let fullColumn = {};
    let filtered = columns.filter(o => o.name === name);
    if (filtered.length) {
        fullColumn = filtered[0];
    } else {
        fullColumn = name;
    }
    return fullColumn
}

function getColumnType(columns, name) {
    const filtered = columns.filter(c => c.name === name);
    return filtered.length ? filtered[0].type : undefined
}